import React from 'react';
import ReactDOM from 'react-dom/client';
import { Portal } from '@aicores/ui';
import type { PortalContent } from '@aicores/ui';
import '@aicores/brand/styles.css';
import content from './content/prompts.json';

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <Portal
      content={content as PortalContent}
      entitlementEndpoint={import.meta.env.VITE_ENTITLEMENT_URL ?? ''}
      eventsEndpoint={import.meta.env.VITE_EVENTS_URL ?? ''}
      debugEvents={import.meta.env.DEV}
    />
  </React.StrictMode>,
);
